import {mergeMap, take} from 'rxjs/operators';
import {Injectable, Injector} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Client, KcApplicationResult} from '../services/api.client';
import {combineLatestWith, Observable} from 'rxjs';
import {KcApplicationService} from '../services/KcApplicationService';
import {ClientService} from '../services/ClientService';

@Injectable()
export class ResolveClientKcApplications  {

  client$: Observable<Client>;
  application$: Observable<KcApplicationResult>;

  constructor(private injector: Injector,
              private _clientService: ClientService,
              private _kcApplicationService: KcApplicationService) {
    this.client$ = this._clientService.currentClient$;
    this.application$ = this._kcApplicationService.currentSelectedKcApplication$;
  }


  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return this.application$.pipe(
      combineLatestWith(this.client$.modelExists()),
      take(1),
      mergeMap(([, client]) => this.injector.get(KcApplicationService).getKcApplicationsByClientId(client.id)), );
  }
}
